module.exports = __webpack_public_path__ + "./docs/img/ai.e92136fc6711181f08f03b9f2e87399b.svg";